package com.narbase.letsgo.web.views.pushpayload

import com.narbase.kunafa.core.lifecycle.Observable
import com.narbase.letsgo.dto.core.KmmLong
import com.narbase.letsgo.dto.dto
import com.narbase.letsgo.web.dto.passengers.ExtendedPassengerDto
import com.narbase.letsgo.web.models.pushpayload.PushDeliveryPriority
import com.narbase.letsgo.web.models.pushpayload.PushDeliveryType
import com.narbase.letsgo.web.network.basicNetworkCall
import com.narbase.letsgo.web.network.remoteProcess
import com.narbase.letsgo.web.routing.domain.admin.pushpayload.GetPushSendHistoryEndpoint
import com.narbase.letsgo.web.routing.domain.admin.pushpayload.SendPushPayloadEndpoint
import com.narbase.letsgo.web.utils.BasicUiState

class PushPayloadManagementViewModel {

    val sendPayloadUiState = Observable<BasicUiState>()
    val getHistoryUiState = Observable<BasicUiState>()

    var recipients = mutableListOf<ExtendedPassengerDto>()
    var useSandbox = false
    var priority = PushDeliveryPriority.IMMEDIATE
    var deliveryType = PushDeliveryType.ALERT
    var expiresInSeconds: Int? = null
    var alertTitle = "Test title"
    var alertBody = "Test body"
    var payloadJson = defaultPayloadJson
    var lastSendResponse: SendPushPayloadEndpoint.Response? = null
    var history: List<GetPushSendHistoryEndpoint.PushSendDto> = listOf()

    val recipientsCount: Int
        get() = recipients.size

    fun addRecipient(passenger: ExtendedPassengerDto): Boolean {
        val passengerId = passenger.passenger.id ?: return false
        if (recipients.any { it.passenger.id == passengerId }) return false
        recipients.add(passenger)
        return true
    }

    fun removeRecipient(passengerId: KmmLong) {
        recipients.removeAll { it.passenger.id == passengerId }
    }

    fun clearRecipients() {
        recipients = mutableListOf()
    }

    fun sendPayload() {
        basicNetworkCall(sendPayloadUiState) {
            val dto = SendPushPayloadEndpoint.Request(
                passengerIds = recipients.mapNotNull { it.passenger.id }.toTypedArray(),
                payloadJson = payloadJson,
                useSandbox = useSandbox,
                priority = priority.dto(),
                deliveryType = deliveryType.dto(),
                expiresInSeconds = expiresInSeconds,
                alertTitle = alertTitle,
                alertBody = alertBody,
            )
            lastSendResponse = SendPushPayloadEndpoint.remoteProcess(dto).data
        }
    }

    fun getHistory() {
        basicNetworkCall(getHistoryUiState) {
            val dto = GetPushSendHistoryEndpoint.Request()
            history = GetPushSendHistoryEndpoint.remoteProcess(dto).data.sends.toList()
        }
    }

    fun setSendPayloadUiStateToNull() {
        sendPayloadUiState.value = null
    }

    companion object {
        const val defaultPayloadJson = """{
  "status": "20",
  "title": "Test title",
  "body": "Test body"
}"""
    }
}
